import { useEffect, useState } from 'react';
import useModuleMetadata from 'src/hooks/use-module-metadata.hook';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import {
  getModuleSequence,
  getDynamicBreadcrumbs,
  getScenarioDetails
} from '../../home/store/simulator-home-async-thunks';
import MODULE_TO_PAGE_MAP from '../../home/types/simulation-module-to-page-map';

interface IModulePreRequisitesHookArg {
  /**
   * Current module user is on
   */
  module: MODULE_TO_PAGE_MAP;
  /**
   * A call back which is called when all of the
   * pre requisite data is fetched.
   * Ideally this is where you should fetch all the further
   * data that you require for you module.
   * @returns void
   */
  onPreRequisitesFetched?: () => void;
}

/**
 * A hook to initially fetch all the data that is required for a given module
 * @returns State variable indicating whether pre requisite are being fetched
 */
export default function useModulePreRequisites({
  module,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onPreRequisitesFetched = () => { }
}: IModulePreRequisitesHookArg) {
  const appDispatch = useAppDispatch();
  const [isFetchingPreRequisites, setIsFetchingPreRequisites] = useState(false);
  const [isPreRequisitesFetched, setIsPreRequisitesFetched] = useState(false);
  const { sourceId, scenarioId, moduleId } = useModuleMetadata({
    module
  });
  const { moduleSequence, currentScenario, moduleAccessMap } = useAppSelector(
    (state) => state.simulatorHome
  );

  useEffect(() => {
    if (
      !moduleSequence.length ||
      (!currentScenario && !Number.isNaN(Number(scenarioId))) ||
      Object.values(moduleAccessMap).some((value) => !value)
    ) {
      setIsFetchingPreRequisites(true);
      appDispatch(getScenarioDetails({ scenarioId, sourceId }))
        .then()
        .then(() => {
          appDispatch(getModuleSequence(sourceId));
          appDispatch(getDynamicBreadcrumbs(sourceId));
        })
        .catch((err) => {
          console.error('Error fetching pre requisites', err);
          setIsFetchingPreRequisites(false);
        });
    }
  }, []);

  useEffect(() => {
    if (moduleId) {
      setIsFetchingPreRequisites(false);
      onPreRequisitesFetched();
    } else {
      setIsFetchingPreRequisites(false);
    }
  }, [moduleId]);

  return {
    isFetchingPreRequisites
  };
}
